module.exports = __webpack_public_path__ + "static/fonts/iconfont.5ac11846.ttf";